// ── THEME COLORS ─────────────────────────────────────────────────
export const C = {
  bg:           "#FAF7F4",
  surface:      "#F2ECE6",
  card:         "#FFFFFF",
  cardHover:    "#FDF9F6",
  border:       "#E0D5C8",
  borderLight:  "#C8BAA8",
  text:         "#2A1F18",
  muted:        "#7A6858",
  dim:          "#B5A393",
  burgundy:     "#7B1C2E",
  burgundyDark: "#5C1220",
  burgundyLight:"#9B3245",
  burgundyBg:   "rgba(123,28,46,0.08)",
  gold:         "#B8860B",
  goldLight:    "#D4A832",
  goldBg:       "rgba(184,134,11,0.10)",
  forest:       "#2C5F3F",
  forestLight:  "#3D7A53",
  forestBg:     "rgba(44,95,63,0.10)",
  rust:         "#8B4A2A",
  rustBg:       "rgba(139,74,42,0.10)",
  cyan:         "#2C5F6A",
  purple:       "#5B3A6B",
  aiPurple:     "#5B3A6B",
  aiPurpleBg:   "rgba(91,58,107,0.08)",
  navy:         "#1E3A5F",
  navyBg:       "rgba(30,58,95,0.08)",
};
